import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import SelectSearch, { fuzzySearch } from "react-select-search";

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  FormFeedback,
  Spinner,
} from "reactstrap";

import Header from "components/Headers/Header";
import { editPatient } from "store/services/patient.service";
import { getPatients } from "store/services/patient.service";
import { GET_PATIENTS } from "store/types";
import { useHistory } from "react-router-dom";

const PatientForm = (props) => {
  const { patients } = useSelector((state) => state.patients);
  const { role } = JSON.parse(window.sessionStorage.getItem("user"));
  const { exams, doctors } = useSelector((state) => state.exams);

  const option = doctors.map((item) => {
    return { name: item.name, value: item.name };
  });
  const dispatch = useDispatch();
  const history = useHistory();

  const { pname } = props?.location?.state || "No Name";

  const patient = [...patients].find((item, index) =>
    item.patient_name === pname ? item : null
  );

  // Input State
  const [editMood, setEditMood] = useState(false);
  const [patientName, setPatientName] = useState(pname);
  const [doctorName, setDoctorName] = useState(
    patient?.doctor_name || "No Doctor Provided"
  );

  const [price, setPrice] = useState(patient?.price);
  const [patientPhone, setPatientPhone] = useState(patient?.mobile);
  const [patientAge, setPatientAge] = useState(patient?.age);
  const [patientGender, setPatientGender] = useState(patient?.gender || "Male");
  const [patientExam, setPatientExam] = useState(patient?.exam);
  const [patientNotes, setPatientNotes] = useState(patient?.notes);
  const [patientStatus, setPatientStatus] = useState(
    patient?.status?.toUpperCase() || "PENDING"
  );
  const [showSpinner, setShowSpinner] = useState(false);
  const id = patient.id;

  // Input Validation
  const [isPhone, setIsPhone] = useState(false);
  const [isName, setIsName] = useState(false);
  const [isAge, setIsAge] = useState(false);
  const [isPrice, setIsPrice] = useState(false);

  const handelSave = (e) => {
    setShowSpinner(true);
    if (isNaN(price) || !price) {
      setIsPrice("the Price is not a number");
    }
    if (!patientName) {
      setIsName("Name can not be empty");
    }
    if (!patientAge) {
      setIsAge("Age is not correct");
    }
    const data = {
      patient_name: patientName,
      mobile: patientPhone,
      doctor_name: doctorName,
      age: patientAge,
      gender: patientGender,
      exam: patientExam,
      notes: patientNotes,
      price: price,
      status: patientStatus,
      id: id,
    };
    if (!isPrice && !isName && !isAge) {
      editPatient(data).then((ops) => {
        getPatients().then((data) => {
          dispatch({ type: GET_PATIENTS, payload: data });
        });
        history.push("/admin/tables");
      });
    }
  };

  const handelEdit = () => {
    setEditMood(!editMood);
  };

  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--9" fluid>
        <Row>
          <Col className="order-xl-1" xl="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">{pname}</h3>
                  </Col>
                  {(role.type === "center" || role.type === "admins") && (
                    <Col className="text-right" xs="4">
                      {showSpinner ? (
                        <Spinner color="primary" />
                      ) : (
                        <Button
                          color="primary"
                          onClick={handelSave}
                          size="sm"
                          disabled={!editMood}
                        >
                          SAVE
                        </Button>
                      )}

                      <Button color="primary" onClick={handelEdit} size="sm">
                        {editMood ? "Cancel" : "Edit"}
                      </Button>
                    </Col>
                  )}
                </Row>
              </CardHeader>
              <CardBody>
                <Form>
                  <h6 className="heading-small text-muted mb-4">
                    Patient information
                  </h6>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-username"
                          >
                            Name
                          </label>
                          <Input
                            className="form-control-alternative"
                            defaultValue={pname}
                            onChange={(e) => {
                              setPatientName(e.target.value);
                              setShowSpinner(false);
                              setIsName(false);
                            }}
                            id="input-username"
                            placeholder="name"
                            type="text"
                            invalid={isName}
                            disabled={!editMood}
                          />
                          <FormFeedback>{isName}</FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-email"
                          >
                            Phone Number
                          </label>
                          <Input
                            className="form-control-alternative"
                            onChange={(e) => {
                              setPatientPhone(e.target.value);
                              setShowSpinner(false);

                              setIsPhone(false);
                            }}
                            id="input-email"
                            placeholder="079*******"
                            defaultValue={
                              patient?.mobile || "No Phone Number Provided "
                            }
                            type="phone"
                            disabled={!editMood}
                            invalid={isPhone}
                          />
                          <FormFeedback>{isPhone}</FormFeedback>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-first-name"
                          >
                            Age
                          </label>
                          <Input
                            onChange={(e) => {
                              setPatientAge(e.target.value);
                              setShowSpinner(false);

                              setIsAge(false);
                            }}
                            className="form-control-alternative"
                            defaultValue={patient?.age || "No Age Provided"}
                            id="input-first-name"
                            placeholder="First name"
                            type="text"
                            invalid={isAge}
                            disabled={!editMood}
                          />
                          <FormFeedback>{isAge}</FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-last-name"
                          >
                            Gender
                          </label>
                          <Input
                            onChange={(e) => setPatientGender(e.target.value)}
                            className="form-control-alternative"
                            id="input-last-name"
                            placeholder="Last name"
                            type="select"
                            defaultValue={
                              patient?.gender || "No Gender Provided"
                            }
                            disabled={!editMood}
                          >
                            <option>Male</option>
                            <option>Female</option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-first-name"
                          >
                            Exam
                          </label>
                          <Input
                            onChange={(e) => setPatientExam(e.target.value)}
                            className="form-control-alternative"
                            id="input-first-name"
                            placeholder="First name"
                            type="select"
                            defaultValue={patient?.exam || "No Exam Provided"}
                            disabled={!editMood}
                          >
                            {exams?.map((item) => (
                              <option>{item}</option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-username"
                          >
                            Status
                          </label>
                          <Input
                            onChange={(e) => setPatientStatus(e.target.value)}
                            className="form-control-alternative"
                            id="input-username"
                            placeholder="name"
                            value={patientStatus || "PENDING"}
                            type="select"
                            disabled={!editMood}
                          >
                            <option>COMPLETED</option>
                            <option>PENDING</option>
                            <option>CANCEL</option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    {(role.type === "center" || role.type === "admins") && (
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-last-name"
                            >
                              Doctor
                            </label>
                            <SelectSearch
                              disabled={!editMood}
                              onChange={(e) => setDoctorName(e)}
                              options={option}
                              search
                              filterOptions={fuzzySearch}
                              emptyMessage={() => (
                                <div
                                  style={{
                                    textAlign: "center",
                                    fontSize: "0.8em",
                                  }}
                                >
                                  Not found renderer
                                </div>
                              )}
                              placeholder={doctorName}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-first-name"
                            >
                              Price
                            </label>
                            <Input
                              onChange={(e) => {
                                setPrice(e.target.value);
                                setIsPrice(false);
                                setShowSpinner(false);
                              }}
                              className="form-control-alternative"
                              defaultValue={patient?.price}
                              id="input-first-name"
                              placeholder="Price Example : 30.60"
                              type="text"
                              disabled={!editMood}
                              invalid={isPrice}
                            />
                            <FormFeedback>{isPrice}</FormFeedback>
                          </FormGroup>
                        </Col>
                      </Row>
                    )}
                  </div>
                  <hr className="my-4" />
                  {/* Description */}
                  <h6 className="heading-small text-muted mb-4">
                    Doctor Notes
                  </h6>
                  <div className="pl-lg-4">
                    <FormGroup>
                      <Input
                        onChange={(e) => setPatientNotes(e.target.value)}
                        className="form-control-alternative"
                        rows="4"
                        defaultValue={patient?.notes || "No Notes Provided"}
                        type="textarea"
                        disabled={!editMood}
                      />
                    </FormGroup>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default PatientForm;
